
var SpotifyService = (function() {
    var $ = require('jquery');
    var base_url = 'https://api.spotify.com/v1';

    var callApi = function (path) {
        return $.ajax(base_url + path);
    }

    return {
        findTracks: function (query) {
            console.log('[SpotifyService: finding tracks: ' + query + ']');

            return callApi('/search?type=track&q=' + encodeURIComponent(query));
        },
        getTrack: function (id) {
            console.log('[SpotifyService: getting track: ' + id + ']');

            return callApi('/tracks/' + encodeURIComponent(id));
        },
        getPreviewUrlFromTrack: function (track) {
            return track.preview_url;
        },
        getPreviewUrlFromId: function (id) {
            var getSong = this.getTrack(id);
            var mp3 = getSong.then(this.getPreviewUrlFromTrack);

            return mp3;
        }
    };
})();

module.exports = SpotifyService;
